<template>
  <div class="control-app-page">
    <div class="page-crumbs">
      <span class="crumbs-link" @click="goControlIndex">我的应用</span> / <span>应用管理</span>
      <span v-if="showSandboxSwitch && sandbox===0" class="env-box master" style="padding-left: 0px; bottom: 1px; font-size: 14px">(正式)</span>
      <span v-if="showSandboxSwitch && sandbox===1" class="env-box sandbox " style="padding-left: 0px; bottom: 1px; font-size: 14px">(沙箱)</span>
    </div>
    <div class="content-body">
      <div class="app-menu-box">
        <div v-for="item in menuList" :key="item.path" 
             :class="['app-menu-item', {'active': $route.path.indexOf(item.path) !== -1}]" @click="menuItemClick(item)">
          {{item.name}}
        </div>
      </div>
      <div class="app-content-box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import {sandboxRequest} from "../../../axios/sandboxRequest";

  export default {
    data() {
      return {
        appId: '',
        menuList: [
          {
            path: '/control/app/info/',
            name: '基本信息',
          }, {
            path: '/control/app/voucher/',
            name: '证书信息',
          }, {
            path: '/control/app/flow/',
            name: 'API权限',
          }, {
            path: '/control/app/auth/',
            name: '用户授权',
          },
        ]
      }
    },
    computed: {
      
    },
    mounted() {
      this.appId = this.$route.params.appId;
      this.envIsOpen();
    },
    methods: {
      envIsOpen() { // 沙箱环境是否开启
        sandboxRequest.showSandboxEnv().then(res => {
          this.showSandboxSwitch = res.ret === 0 && res.data;
        })
      },
      goControlIndex() {
        this.push('/control/myapp')
      },
      menuItemClick(item) {
        if(this.$route.path.indexOf(item.path) !== -1) {
          return
        }
        this.push(item.path + this.appId)
      },
      push(path) { // 这个页面push都需要使用这个方法来push，如果还有别的参数，需要改造方法，将参数一起拼接进去
        this.$router.push({path: path, query: {sandbox: this.sandbox ? '1' : '0'}});
      },
    }
  }
</script>

<style lang="scss" scoped>
  .control-app-page {
    width: 1170px;
    padding: 0 0 30px;
    margin: 0 auto;
    .page-crumbs {
      width: 100%;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      color: rgba(0,0,0,0.65);
      padding-left: 10px;
      margin: 15px 0;
      .crumbs-link {
        color: rgba(0,0,0,0.45);
        cursor: pointer;
        &:hover {
          color: #f16622;
        }
      }
    }
  }
  .content-body {
    position: relative;
    min-height: 500px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  }
  .app-menu-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 237px;
    height: 100%;
    padding-top: 24px;
    background: #F4F5F6;
    box-sizing: border-box;
    .app-menu-item {
      width: 100%;
      height: 57px;
      line-height: 57px;
      color: #212121;
      font-size: 16px;
      padding-left: 48px;
      border-left: 6px solid transparent;
      box-sizing: border-box;
      cursor: pointer;
      &.active {
        color: #F16622;
        background: #fff;
        border-left-color: #F16622;
      }
    }
  }
  .app-content-box {
    width: 100%;
    padding-left: 240px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/control/app/app.vue